import { render } from "./Callouts.vue?vue&type=template&id=2a3fa53a&scoped=true"
import script from "./Callouts.vue?vue&type=script&lang=js"
export * from "./Callouts.vue?vue&type=script&lang=js"

import "./Callouts.vue?vue&type=style&index=0&id=2a3fa53a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a3fa53a"]])

export default __exports__